import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts'

import { deserializeUrl } from '../utils/url-utils'

let automaticReauthenticationSuppressed = false

export function setAutomaticReauthenticationSuppressed(suppressed: boolean) {
  automaticReauthenticationSuppressed = suppressed
}

export function isAutomaticReauthenticationSuppressed() {
  return automaticReauthenticationSuppressed
}

export function resolveTenant() {
  let toReturn = ''
  const cleanUrl = window.location.pathname.slice(1)
  const splitted = cleanUrl.split('/')

  if (splitted.length) {
    toReturn = splitted[0]
  }

  return toReturn
}

export function getRedirectUrl() {
  let toReturn = ''
  const cleanUrl = window.location.pathname.slice(1)
  toReturn = cleanUrl + window.location.search
  return toReturn
}

export function hasTenant() {
  return !!resolveTenant()
}

/**
 * add the idle\expiredlink query params to query string if it is present in the url
 * this is used to let the login page know that we are coming from a logout for inactivity
 */
function resolveExtraParams() {
  const query = new URLSearchParams(window.location.search)

  const idle = Boolean(query.get('idle'))
  const expiredlink = Boolean(query.get('expiredlink'))

  if (idle || expiredlink) {
    const extraParamsDict = {} as Record<string, boolean>
    if (idle) {
      extraParamsDict.idle = true
    } else if (expiredlink) {
      extraParamsDict.expiredlink = true
    }
    return extraParamsDict
  }
  return undefined
}

function resolveBusinessUnit() {
  const businessUnit = deserializeUrl(window.location.search)['BUSINESS_UNIT']
  if (businessUnit) {
    return `business_unit:${businessUnit}`
  }
  return ''
}

export const IDENTITY_CONFIG: UserManagerSettings = {
  //(string): The URL of the OIDC provider.
  authority: window.__APP_CONFIG__.AUTHORITY as string,
  //(string): Your client application's identifier as registered with the OIDC provider.
  client_id: 'mvc',
  //The URI of your client application to receive a response from the OIDC provider.
  redirect_uri: `${window.__APP_CONFIG__.CLIENT}/${resolveTenant()}`,
  //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
  loadUserInfo: true,
  filterProtocolClaims: true,
  // (string): The OIDC post-logout redirect URI.
  post_logout_redirect_uri: `${window.__APP_CONFIG__.CLIENT}/${resolveTenant()}`,
  //(string, default: 'id_token'): The type of response desired from the OIDC provider.
  response_type: 'code',
  response_mode: 'query',
  //(string, default: 'openid'): The scope being requested from the OIDC provider.
  scope: 'openid profile corelib roles',
  acr_values: hasTenant() ? [`tenant:${resolveTenant()}`, resolveBusinessUnit()].join(' ') : ``,
  monitorSession: false,
  extraQueryParams: resolveExtraParams(),

  userStore: new WebStorageStateStore({
    prefix: `${resolveTenant()}.`,
    store: window.sessionStorage,
  }),
}
